module.exports = __webpack_public_path__ + "assets/img/mom_daughter.b6907fc3.jpg";